import { render, staticRenderFns } from "./SecaoComoFunciona.vue?vue&type=template&id=2037abd4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SecaoComoFunciona.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoComoFunciona.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SecaoComoFunciona.vue?vue&type=style&index=0&id=2037abd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037abd4",
  null
  
)

export default component.exports